import { ListingColDefs } from './listing-col-defs';

/**
 * Class for constructing column defs for Pending (Unknown) Listing Data
 *
 * @export
 * @class PendingColDefs
 * @extends {ListingColDefs}
 */
export class PendingColDefs extends ListingColDefs {
  longTermStayComplianceColGroup = {
    headerName: 'Long Term Stay Compliance',
    children: [this.minimumStayAdvertisedColumn],
  };

  pdfUrlColumn = {
    ...this.pdfUrlColumn,
    pinned: undefined,
  };

  verifiedColumn = {
    ...this.verifiedColumn,
    pinned: undefined,
  };

  strLicenseDisplayedColumn = this.textColumn({
    headerName: 'Displayed License',
    field: 'strLicenseDisplayed',
    width: 150,
  });

  listingsInfoColGroup = {
    headerName: 'Listing information',
    children: [
      this.hostColumn,
      this.listingIdColumn,
      this.listingUrlColumn,
      this.pdfUrlColumn,
      this.verifiedColumn,
      this.strLicenseDisplayedColumn,
      this.titleColumn,
      this.createdOnColumn,
      this.unitTypeColumn,
      this.rentalStructureColumn,
      this.rentalTypeColumn,
      this.minimumNightStayColumn,
      this.violationsColumn,
    ],
  };

  /**
   * Groups of columns for Pending
   *
   * @override
   */
  columnGroups() {
    return [
      this.listingsInfoColGroup,
      this.occupancyComplianceColGroup,
      this.longTermStayComplianceColGroup,
      this.bedroomInfoColGroup,
      this.otherInfoColGroup,
      this.bookingInfoColGroup,
    ];
  }
}
